import {
  FormControl,
  FormLabel,
  Box,
  Grid,
  TextField,
  Button,
  Typography,
} from '@mui/material'
import { inject, observer } from 'mobx-react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { AuthStore, RoutingStore } from 'stores'
import { Icon, SnackBarContext } from 'components'

export interface IBankIdSettingsProps {
  authStore?: AuthStore
  routingStore?: RoutingStore
}

/**
 * Displays the connector towards bankId for a user
 *
 * @type Participant, Editor, Group
 */

export const BankIdSettings = inject(
  'authStore',
  'routingStore'
)(
  observer((props: IBankIdSettingsProps) => {
    const { t } = useTranslation()
    const { authStore } = props
    const { toast } = React.useContext(SnackBarContext)

    
    React.useEffect(() => {
      const validateCallback = async () => {
        const queryString = window.location.search
        const urlParams = new URLSearchParams(queryString)
        const grandidsession = urlParams.get('grandidsession')
        if (grandidsession) {
          const result =
            props.authStore.validateBankIdConnectCallback(grandidsession)
          const url = new URL(window.location.href)
          url.searchParams.delete('grandidsession')
          window.history.replaceState({}, '', url)
          if (result) {
            toast(t('toast_success_bankid_connected'), 'success')
          } else {
            toast('toast_success_bankid_not_connected', 'error')
          }
        }
      }
    validateCallback();
    }, [])

    return (
      <Grid item xs={12} md={12}>
        <FormControl fullWidth margin='normal'>
          {authStore.getCurUser.personal_number && (
            <>
              <FormLabel>{t('personal_number')}</FormLabel>
              <TextField
                hiddenLabel
                variant='outlined'
                disabled={true}
                sx={{ border: 'none' }}
                value={authStore.getCurUser.personal_number || ''}
              />
            </>
          )}
          {/* <Box mt={3}>
          {authStore.getCurUser.personal_number && (
            <Button
              variant='contained'
              onClick={() => authStore.unlinkBankId()}
            >
              <Typography
                variant='body2'
                ml={3}
                textAlign='center'
                fontWeight='600'
                mr={3}
              >
                {t('remove_bankid')}
              </Typography>
              <Icon iconId='bank-id' size={'size-24'} />
            </Button>
          )}
          {!authStore.getCurUser.personal_number && (
            <Button
              variant='contained'
              onClick={() => props.authStore.connectBankId()}
            >
              <>
                <span>{t('connect_bankid')}</span>
                <Icon iconId='bank-id' size={'size-24'} />
              </>
            </Button>
          )}
          </Box> */}
        </FormControl>
      </Grid>
    )
  })
)
